var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { urlMiddleware } from 'react-relay-network-modern/es';
import { RelayEnvironmentProvider } from 'react-relay/hooks';
import { useExtendedLogger } from '../../Logger';
import { initEnvironment } from '../helpers';
import { LOGGER_NAME } from '../constants';
import { appendQueryName } from '../helpers/middlewares/appendQueryName';
var withRelay = function (_a) {
    var graphqlEndpoint = _a.graphqlEndpoint, _b = _a.middlewares, middlewares = _b === void 0 ? [] : _b, _c = _a.options, options = _c === void 0 ? {} : _c, environmentOptions = _a.environmentOptions;
    var enhancer = function (Component) { return function (props) {
        var log = useExtendedLogger(LOGGER_NAME);
        var environment = useMemo(function () {
            log('initialising environment with %s graphql endpoint', graphqlEndpoint);
            return initEnvironment({
                network: {
                    middlewares: __spread([
                        urlMiddleware({ url: graphqlEndpoint, credentials: 'include' })
                    ], middlewares, [
                        appendQueryName(),
                    ]),
                    options: options,
                },
                environmentOptions: environmentOptions,
            });
        }, [log]);
        log('adding provider with %o environment', environment);
        return (_jsx(RelayEnvironmentProvider, __assign({ environment: environment }, { children: _jsx(Component, __assign({}, props), void 0) }), void 0));
    }; };
    return enhancer;
};
export default withRelay;
//# sourceMappingURL=withRelay.js.map